<script setup>
    import { ref, computed, onMounted } from 'vue'
    import { useRoute, useRouter, RouterLink } from 'vue-router'
    import {usePageLoadingStore} from "../../../../../stores/pageLoading";
    import SNBAdmin from '../../../../../layouts/nav/SNBAdmin.vue'
    import insightsNotifyService from "../../../../user/services/insights/insightsNotifyService";
    import fileService from "../../../../../services/fileService";
    import _ from 'lodash'

    const route = useRoute();
    const router = useRouter();
    const loadingStore = usePageLoadingStore()

    onMounted(()=>{
        const { id } = route.params;
        if(!id) {
            router.push({name: 'CSNotifyList'})
        } else {
            retrieveNoticeDetail(id)
        }
    })

    const MAX_SIZE = 200;
    const input = ref({
        title: '',
        isNotify: false,
        content: '',
        attachList: [
            {
                attachSeq: 0,
                fileName: "",
                fileSize: "",
                fileDir: "",
                deleteYn: "N"
            }
        ],
    })

    const inputError = ref({
        title: '',
        content: '',
        attachList: '',
    })

    const editorRef = ref(null)

    const modal = ref(null);
    const confirmModal = ref(null);
    const modalContent = ref([]);

    const retrieveNoticeDetail = (id) => {
        loadingStore.loading = true;
        insightsNotifyService.retrieveNotifyDetail(id)
            .then( (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    input.value.title = result.title;
                    input.value.isNotify = result.notifyYn === 'Y';
                    input.value.content = result.content;
                    input.value.attachList = result.attachList;
                    if(_.isEmpty(input.value.attachList)) {
                        input.value.attachList = [
                            {
                                attachSeq: 0,
                                fileName: "",
                                fileSize: "",
                                fileDir: "",
                                deleteYn: "N"
                            }
                        ];
                    }

                    editorRef.value.init(input.value.content)
                }
            }).catch( (error) =>  {
            loadingStore.loading = false;
            console.log(error);
        });
    }

    const uploadFile = () => {
        const fileInput = document.createElement('input');
        fileInput.type= 'file';
        fileInput.click();

        fileInput.addEventListener('change', function(event){
            // console.log(event.target.files);
            const file = event.target.files[0];
            // console.log(file);
            if(file.size > (MAX_SIZE*1024*1024)) {
                modalContent.value = [`파일은 최대 ${MAX_SIZE}MB까지 첨부할 수 있습니다.`];
                modal.value.show();
            } else {
                let paramObj = {
                    container: 'public',
                    folder: 'cs_notice',
                    file,
                }

                fileService.uploadFile(paramObj)
                    .then((res) => {
                        // console.log(res);
                        if(res.data.code.toLowerCase() === 'success') {
                            const result = res.data.result;
                            // console.log(result);
                            input.value.attachList[0].fileName = result.originalFilename;
                            input.value.attachList[0].fileSize = result.fileSize;
                            input.value.attachList[0].fileDir = result.blobUrl;
                            // console.log(input.value)
                        }
                    })
                    .catch( (error) =>  {
                        console.log(error);
                    });
            }
        });
    }

    const removeFile = () => {
        input.value.attachList[0].fileName = '';
        input.value.attachList[0].fileSize =  '';
        input.value.attachList[0].fileDir =  '';
    }

    const update = async () => {
        const { title, isNotify, content, attachList } = input.value;
        let isInvalid = false;


        inputError.value = {
            title: '',
            content: '',
            attachList: '',
        };

        if(!title) {
            inputError.value.title = '제목을 입력하세요.';
            isInvalid = true;
        }
        if(!content) {
            inputError.value.content = '내용을 입력하세요.';
            isInvalid = true;
        }

        _.each(attachList, attach => {
            attach.deleteYn = !attach.fileName ? 'Y' : 'N';
        });

        if(!isInvalid) {
          modalContent.value = ["저장하시겠습니까?"];
          const ok = await confirmModal.value.show();

          if(!ok) {
            return -1;
          } else {
            const { id } = route.params;
            let paramObj = {
              boardId: id,
              title,
              notifyYn: isNotify ? "Y" : "N",
              content,
              attachList,
            }

            loadingStore.loading = true;
            insightsNotifyService.updateNotice(paramObj)
              .then((res) => {
                loadingStore.loading = false;
                if (res.data.code.toLowerCase() === 'success') {
                  const result = res.data.result;
                  goBack();
                } else {
                  modalContent.value = ["저장을 실패하였습니다."];
                  modal.value.show();
                }
              }).catch((res) => {
              loadingStore.loading = false;
              // console.log(res);
              modalContent.value = ["저장을 실패하였습니다."];
              modal.value.show();
            });
          }
        }
    }

    const goBack = () => {
        const { id } = route.params;
        router.push({name: 'CSNotifyDetail', params:{ id }})
    };
</script>

<template>
    <div class="container">
        <div class="flex-wrap admin">
            <SNBAdmin class="snb" />
            <div class="content">
                <div class="lecture-wrap">
                    <div class="sub-title">
                        <h3>공지사항 수정</h3>
                    </div>
                    <div class="table-form">
                        <p>모든 정보는 필수입력 사항입니다.</p>
                        <table class="vertical">
                            <colgroup>
                                <col width="110px" />
                                <col />
                            </colgroup>
                            <tr>
                                <th>제목</th>
                                <td>
                                  <KSAInput class="text-box mb-xs" v-model="input.title" :msg="inputError.title" placeholder="제목을 입력하세요."/>
                                  <KSACheckBox label="상단 공지사항으로 설정합니다." v-model="input.isNotify"  />
                                </td>
                            </tr>
                            <tr>
                                <th>내용</th>
                                <td>
                                    <KSACKEditor ref="editorRef" v-model="input.content"/>
                                    <div>
                                        <small style="color:#E71414;">{{ inputError.content }}</small>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>첨부</th>
                                <td class="text-box">
                                    <div class="grid file" v-for="attach in input.attachList">
                                        <KSAPrimaryButton text="파일 선택" @click="uploadFile" />
                                        <KSAInput class="input icon" v-model="attach.fileName" disabled />
                                        <button class="delete" @click="removeFile" :disabled="!attach.fileName"><i></i></button>
                                    </div>
                                    <small>최대 {{ MAX_SIZE }}MB 까지 첨부 가능</small>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="btn-wrap space-between">
                        <KSASecondaryButton class="gray_button" text="취소" @click="goBack" />
                        <KSAPrimaryButton text="저장" :disabled="!input.title || !input.content " @click="update" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <AlertModal ref="modal" :content="modalContent" />
    <ConfirmModal ref="confirmModal" :content="modalContent" />
</template>

<style lang="scss" scoped>
    @import "../../../../../assets/scss/theme";

    .textarea-box {
        height: 300px;
    }
    small {
        @include font-size_xs;
        color: $gray_color;
    }
</style>